import { getLocalDate } from '@shared/utils'
import { monthAndYearRule } from '@shared/validation'
import { startOfMonth } from 'date-fns'

import { formDateStringToDate, monthAndYearStringToDate } from './date'
import { VestRuleReturn } from './types'

const monthAndYearRegExp = new RegExp(monthAndYearRule)

export const isValidMonthAndYearFormat = (str: string): VestRuleReturn => {
  return monthAndYearRegExp.test(str)
}

export const isFullDateNotInFuture = (fullDate: string): VestRuleReturn => {
  const date = formDateStringToDate(fullDate)
  return date === null ? false : date <= getLocalDate()
}

export const isFullDateNotBefore = (fullDate: string, fullDate2: string): VestRuleReturn => {
  const date1 = formDateStringToDate(fullDate)
  const date2 = formDateStringToDate(fullDate2)
  return date1 === null || date2 === null ? false : date1 >= date2
}

export const isFullDateAfter = (fullDate: string, fullDate2: string): VestRuleReturn => {
  const date1 = formDateStringToDate(fullDate)
  const date2 = formDateStringToDate(fullDate2)
  return date1 === null || date2 === null ? false : date2 <= date1
}

export const isMonthYearNotInPast = (monthAndYear: string): VestRuleReturn => {
  const date = monthAndYearStringToDate(monthAndYear)
  return date >= startOfMonth(new Date())
}

export const isMonthYearNotInFuture = (monthAndYear: string): VestRuleReturn => {
  const date = monthAndYearStringToDate(monthAndYear)
  return date <= startOfMonth(new Date())
}

export const isMonthYearNotBefore = (monthAndYear: string, monthAndYear2: string): VestRuleReturn => {
  const date1 = monthAndYearStringToDate(monthAndYear)
  const date2 = monthAndYearStringToDate(monthAndYear2)
  return date1 >= date2
}

export const isMonthYearAfter = (monthAndYear: string, monthAndYear2: string): VestRuleReturn => {
  const date1 = monthAndYearStringToDate(monthAndYear)
  const date2 = monthAndYearStringToDate(monthAndYear2)
  return date2 <= date1
}
